import { getInfo, setInfo,removeInfo } from '@/utils/storage'

export default {
  namespaced: true,
  state () {
    return {
      userInfo: getInfo()
    }
  },
  mutations: {
    setUserInfo (state, obj) {
      state.userInfo = obj
      setInfo(obj)
    }
  },
  actions: {
    logout (context) {
      context.commit('setUserInfo', {})
      removeInfo()
      context.commit('cart/setCartList', [], { root: true })
    }
  },
  getters: {}
}
